import { render, staticRenderFns } from "./ServiceTypeDetails.handler.vue?vue&type=template&id=495a07eb&"
import script from "./ServiceTypeDetails.handler.vue?vue&type=script&lang=ts&"
export * from "./ServiceTypeDetails.handler.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports